import React, { useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Box } from "@mui/material";
import { OutlinedInput } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import HomeIcon from "@mui/icons-material/Home";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Chip from "@mui/material/Chip";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Restricted from "components/Restricted";
import { IMaskInput } from "react-imask";
import axios from "axios";
import * as XLSX from "xlsx";
import {
  ContactPage,
  ContentPasteOutlined,
  Delete,
  Edit,
  EventNote,
  ImportContacts,
  PersonAdd,
} from "@mui/icons-material";

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+00(#00) 000-0000"
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const options = {
  smooth: true,
};

const Promotores = () => {
  const [items, setItems] = React.useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  const [datosInfoPromotor, setDatosInforPromotor] = React.useState([]);

  const nav = useNavigate();

  //Theme
  const theme = useTheme();

  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //Modal Style
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    width: isSmallScreen ? "90%" : "40%",
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };

  const modalEliminarStyle = {
    position: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isSmallScreen ? "80%" : "30%",
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 1,
    p: 4,
  };

  const modalInfoStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    width: isSmallScreen ? "90%" : "35%",
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
  };

  //Modal States
  const [modalPromotor, setModalPromotor] = React.useState(false);
  const [idEditar, setIdEditar] = React.useState("");
  const handleOpenModalPromotor = () => setModalPromotor(true);
  const handleCloseModalPromotor = () => {
    setModalPromotor(false);
    setNombrePromotor("");
    setApellidoPromotor("");
    setCedulaPromotor("");
    setTelefonoPromotor("");
    setEstadoPromotor("");
    setMunicipioPromotor("");
    setParroquiaPromotor("");
    setComunidadPromotor("");
    setCensoPromotor("");
  };

  const [modalEditarPromotor, setModalEditarPromotor] = React.useState(false);
  const handleOpenEditarPromotor = (datos) => {
    setIdEditar(datos.original.id);
    setNombrePromotorEditar(datos.original.nombres);
    setApellidoPromotorEditar(datos.original.apellidos);
    setCedulaPromotorEditar(datos.original.cedula);
    setTelefonoPromotorEditar({ textmask: datos.original.telefono });
    setCensoPromotorEditar(datos.original.censo);
    setEstadoPromotorEditar(datos.original.estado);
    setMunicipioPromotorEditar(datos.original.municipio);
    setParroquiaPromotorEditar(datos.original.parroquia);
    setComunidadPromotorEditar(datos.original.comunidad);

    setModalEditarPromotor(true);
  };
  const handleCloseEditarPromotor = () => {
    setModalEditarPromotor(false);
    setNombrePromotorEditar("");
    setApellidoPromotorEditar("");
    setCedulaPromotorEditar("");
    setTelefonoPromotorEditar("");
    setEstadoPromotorEditar("");
    setMunicipioPromotorEditar("");
    setParroquiaPromotorEditar("");
    setComunidadPromotorEditar("");
    setCensoPromotorEditar("");
  };

  const [modalEliminarPromotor, setModalEliminarPromotor] =
    React.useState(false);
  const handleOpenModalEliminarPromotor = (datos) =>{ 
    setIdEditar(datos.original.id);
    
    
    setModalEliminarPromotor(true);}
  const handleCloseEliminarPromotor = () => {
    setModalEliminarPromotor(false);
  };

  const [modalInfoPromotor, setModalInfoPromotor] = React.useState(false);
  const handleOpenInfoPromotor = (datos) => {
    setModalInfoPromotor(true);
    setDatosInforPromotor(datos.original);
  };
  const handleCloseInfoPromotor = () => {
    setModalInfoPromotor(false);
  };
  //Alerts Handlers
  const [openNoti, setOpenNoti] = React.useState(false);
  const [openNotiError, setOpenNotiError] = React.useState(false);
  const [openNotiEliminar, setOpenNotiEliminar] = React.useState(false);
  const [openNotiErrorEliminar, setOpenNotiErrorEliminar] = React.useState(false);

  ///////////////////// Primer caracter en mayuscula /////////////////////////
  const oracionFormato = (string) => {
    return string
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  ////////////////////////////////////////////////////////////////////

  //Input States
  const [nombrePromotor, setNombrePromotor] = React.useState("");
  const handleNombrePromotor = (event) => {
    setNombrePromotor(oracionFormato(event.target.value));
  };
  const [apellidoPromotor, setApellidoPromotor] = React.useState("");
  const handleApellidoPromotor = (event) => {
    setApellidoPromotor(oracionFormato(event.target.value));
  };
  const [cedulaPromotor, setCedulaPromotor] = React.useState("");
  const handleCedulaPromotor = (event) => {
    setCedulaPromotor(event.target.value);
  };
  const [telefonoPromotor, setTelefonoPromotor] = React.useState({
    textmask: "",
  });
  const handleTelefonoPromotor = (event) => {
    setTelefonoPromotor({
      ...telefonoPromotor,
      [event.target.name]: event.target.value,
    });
  };
  const [estadoPromotor, setEstadoPromotor] = React.useState("");
  const handleEstadoPromotor = (event) => {
    setEstadoPromotor(event.target.value);
    if (event.target.value == "") {
      setMunicipioPromotor("");
      setParroquiaPromotor("");
    }
  };

  const [municipioPromotor, setMunicipioPromotor] = React.useState("");
  const handleMunicipioPromotor = (event) => {
    setMunicipioPromotor(event.target.value);
  };

  const [parroquiaPromotor, setParroquiaPromotor] = React.useState("");
  const handleParroquiaPromotor = (event) => {
    setParroquiaPromotor(event.target.value);
  };

  const [comunidadPromotor, setComunidadPromotor] = React.useState("");
  const handleComunidadPromotor = (event) => {
    setComunidadPromotor(oracionFormato(event.target.value));
  };

  const [censoPromotor, setCensoPromotor] = React.useState("");
  const handleCensoPromotor = (event) => {
    setCensoPromotor(event.target.value);
  };

  useEffect(() => {
    getMunicipios(estadoPromotor);
    getParroquias(municipioPromotor);
  }, [estadoPromotor, municipioPromotor]);

  //Input States Editar
  const [nombrePromotorEditar, setNombrePromotorEditar] = React.useState("");
  const handleNombrePromotorEditar = (event) => {
    setNombrePromotorEditar(oracionFormato(event.target.value));
  };
  const [apellidoPromotorEditar, setApellidoPromotorEditar] =
    React.useState("");
  const handleApellidoPromotorEditar = (event) => {
    setApellidoPromotorEditar(oracionFormato(event.target.value));
  };
  const [cedulaPromotorEditar, setCedulaPromotorEditar] = React.useState("");
  const handleCedulaPromotorEditar = (event) => {
    setCedulaPromotorEditar(event.target.value);
  };
  const [telefonoPromotorEditar, setTelefonoPromotorEditar] = React.useState({
    textmask: "",
  });
  const handleTelefonoPromotorEditar = (event) => {
    setTelefonoPromotorEditar({
      ...telefonoPromotorEditar,
      [event.target.name]: event.target.value,
    });
  };
  const [estadoPromotorEditar, setEstadoPromotorEditar] = React.useState("");
  const handleEstadoPromotorEditar = (event) => {
    setEstadoPromotorEditar(event.target.value);
    if (event.target.value == "") {
      setMunicipioPromotorEditar("");
      setParroquiaPromotorEditar("");
    }
  };

  const [municipioPromotorEditar, setMunicipioPromotorEditar] =
    React.useState("");
  const handleMunicipioPromotorEditar = (event) => {
    setMunicipioPromotorEditar(event.target.value);
  };

  const [parroquiaPromotorEditar, setParroquiaPromotorEditar] =
    React.useState("");
  const handleParroquiaPromotorEditar = (event) => {
    setParroquiaPromotorEditar(event.target.value);
  };

  const [comunidadPromotorEditar, setComunidadPromotorEditar] =
    React.useState("");
  const handleComunidadPromotorEditar = (event) => {
    setComunidadPromotorEditar(oracionFormato(event.target.value));
  };

  const [censoPromotorEditar, setCensoPromotorEditar] = React.useState("");
  const handleCensoPromotorEditar = (event) => {
    setCensoPromotorEditar(event.target.value);
  };

  useEffect(() => {
    getMunicipios(estadoPromotorEditar);
    getParroquias(municipioPromotorEditar);
  }, [estadoPromotorEditar, municipioPromotorEditar]);

  //BreadCrumbs
  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //Routes
  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };

  const handleLinkVoluntariado = (event, message) => {
    if (message === "voluntariado") {
      nav("/voluntariado");
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "nombres", //access nested data with dot notation
        header: "Nombre",
        size: 150,
      },
      {
        accessorKey: "apellidos",
        header: "Apellido",
        size: 150,
      },
      {
        accessorKey: "cedula",
        header: "Cédula",
        size: 150,
      },
      {
        accessorKey: "telefono",
        header: "Teléfono",
        size: 150,
      },
      {
        accessorKey: "nombreEstado", //normal accessorKey
        header: "Estado",
        size: 200,
      },
      {
        accessorKey: "nombreMunicipio",
        header: "Municipio",
        size: 150,
      },
      {
        accessorKey: "nombreParroquia",
        header: "Parroquia",
        size: 150,
      },
      {
        accessorKey: "comunidad",
        header: "Comunidad",
        size: 150,
      },
      {
        accessorKey: "censo",
        header: "Censo",
        size: 150,
      },
    ],
    []
  );

  const [estados, setEstados] = React.useState([]);
  const [municipios, setMunicipios] = React.useState([]);
  const [parroquias, setParroquias] = React.useState([]);
  const [promotores, setPromotores] = React.useState([]);
  const [municipiosEditar, setMunicipiosEditar] = React.useState([]);
  const [parroquiasEditar, setParroquiasEditar] = React.useState([]);

  const getEstados = async () => {
    try {
      const { data1 } = await axios
        .get("/getEstados/")
        .then(function (response) {
          let datos = response.data;
          console.log(response.data, "Estados");
          setEstados(datos);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getMunicipios = async (id) => {
    try {
      const { data1 } = await axios
        .get("/getMunicipios/", {
          params: {
            id: id,
          },
        })
        .then(function (response) {
          setMunicipios(response.data);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getParroquias = async (id) => {
    try {
      const { data1 } = await axios
        .get("/getParroquias/", {
          params: {
            id: id,
          },
        })
        .then(function (response) {
          console.log(response.data, "Parroquias");
          setParroquias(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const getPromotores = async () => {
    try {
      const { data1 } = await axios
        .get("/getPromotores/")
        .then(function (response) {
          let datos = response.data;
          console.log(response.data, "Promotores");
          setPromotores(datos);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const handleSubmitPromotor = async (event) => {
    try {
      const { data1 } = await axios
        .post("/crearpromotores/", {
          //idConvocatoria: params.idConvocatoria,
          estado: estadoPromotor,
          municipio: municipioPromotor,
          parroquia: parroquiaPromotor,
          comunidad: comunidadPromotor,
          nombres: nombrePromotor,
          apellidos: apellidoPromotor,
          cedula: cedulaPromotor,
          telefono: telefonoPromotor.textmask,
          censo: censoPromotor,
        })
        .then(function (response) {
          setOpenNoti(true);
          setTimeout(() => {
            setOpenNoti(false);
          }, 2000);
          setNombrePromotor("");
          setApellidoPromotor("");
          setCedulaPromotor("");
          setTelefonoPromotor("");
          setEstadoPromotor("");
          setMunicipioPromotor("");
          setParroquiaPromotor("");
          setComunidadPromotor("");
          setCensoPromotor("");
        })
        .catch(function (error) {
          setOpenNotiError(true);
          setTimeout(() => {
            setOpenNotiError(false);
          }, 2000);
        });

      console.log(data1);
    } catch (error) {}

    // handleOpenAlert();
  };

  const handleEditarPromotor = async (event) => {
    try {
      const { data1 } = await axios
        .put("/editarPromotores", {
          id: idEditar,
          estado: estadoPromotorEditar,
          municipio: municipioPromotorEditar,
          parroquia: parroquiaPromotorEditar,
          comunidad: comunidadPromotorEditar,
          nombres: nombrePromotorEditar,
          apellidos: apellidoPromotorEditar,
          cedula: cedulaPromotorEditar,
          telefono: telefonoPromotorEditar.textmask,
          censo: censoPromotorEditar,
        })
        .then(function (response) {
          setOpenNoti(true);
          getPromotores();
          setTimeout(() => {
            setOpenNoti(false);
          }, 2000);
        })
        .catch(function (error) {
          setOpenNotiError(true);
          setTimeout(() => {
            setOpenNotiError(false);
          }, 2000);
        });

      console.log(data1);
    } catch (error) {}
  };


  const handleEliminar = async (event) => {
    try {
      const { data1 } = await axios
        .put("/eliminarPromotores", {
          id: idEditar
         
        })
        .then(function (response) {
          setOpenNotiEliminar(true);
          getPromotores();
          setTimeout(() => {
            setOpenNotiEliminar(false);
          }, 2000);
        })
        .catch(function (error) {
          setOpenNotiErrorEliminar(true);
          setTimeout(() => {
            setOpenNotiErrorEliminar(false);
          }, 2000);
        });

      console.log(data1);
    } catch (error) {}
  };

  const [ejecutar, setEjecutar] = React.useState(true);
  if (ejecutar) {
    getEstados();
    getPromotores();
  }

  return (
    <Box m="1.5rem 2.5rem">
      {rol === "1" || rol === "2" || rol === "7" ? (
        <>
          <Collapse in={openNoti}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNoti(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Datos guardados exitosamente!
            </Alert>
          </Collapse>
          <Collapse in={openNotiError}>
            <Alert
              variant="filled"
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNotiError(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Error al guardar datos!
            </Alert>
          </Collapse>
          <Collapse in={openNotiEliminar}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNotiEliminar(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Datos eliminados exitosamente!
            </Alert>
          </Collapse>
          <Collapse in={openNotiErrorEliminar}>
            <Alert
              variant="filled"
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNotiErrorEliminar(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Datos Eliminados!
            </Alert>
          </Collapse>
          <Box
            role="presentation"
            onClick={handleClickBreadCrumbs}
            sx={{ mb: 3 }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/inicio"
                onClick={(event) => handleLinkHome(event, "home")}
              >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Inicio
              </Link>
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/voluntariado"
                onClick={(event) =>
                  handleLinkVoluntariado(event, "voluntariado")
                }
              >
                <VolunteerActivismIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Voluntariado
              </Link>
              <Typography
                sx={{ display: "flex", alignItems: "center" }}
                color="text.primary"
              >
                <ImportContacts sx={{ mr: 0.5 }} fontSize="inherit" />
                Dir. de Promotores Comunitarios
              </Typography>
            </Breadcrumbs>
            <Typography variant="h3" sx={{ fontWeight: "bold", mt: 2 }}>
              Directorio de Promotores Comunitarios
            </Typography>
            <Box
              mt="10px"
              display="grid"
              gridTemplateColumns="repeat(8, 1fr)"
              gridAutoRows="160px"
              gap="20px"
              sx={{
                "& > div": {
                  gridColumn: isNonMediumScreens ? undefined : "span 12",
                },
              }}
            >
              {/*/////////////////////////////  TABLA DIRECTORIO  ////////////////////////////////*/}
              <Box
                gridColumn="span 8"
                gridRow="span 3"
                backgroundColor={theme.palette.background.alt}
                p="1.5rem"
                borderRadius="1.5rem"
                mt={isSmallScreen ? "3px" : "40px"}
                height="fit-content"
                sx={{ boxShadow: 4 }}
              >
                <Grid
                  container
                  spacing={2}
                  mb={2}
                  justifyContent={isSmallScreen ? "center" : ""}
                >
                  <Grid item xs={11} sm={8}>
                    <Typography
                      className={isSmallScreen ? "text-center" : ""}
                      variant="h5"
                      sx={{ fontWeight: "bold" }}
                    >
                      Listado de Promotores Comunitarios
                    </Typography>
                  </Grid>
                  <Grid item xs={9} sm={4}>
                    <Box
                      container
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                      }}
                    >
                      <Button
                        variant="contained"
                        startIcon={<PersonAdd />}
                        sx={{ bgcolor: "teal", color: "white" }}
                        size={isSmallScreen ? "" : "large"}
                        onClick={handleOpenModalPromotor}
                        fullWidth={isSmallScreen}
                      >
                        Nuevo Promotor
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
                <Divider sx={{ mt: 5, mb: 3 }} />
                <MaterialReactTable
                  columns={columns}
                  data={promotores}
                  localization={MRT_Localization_ES}
                  enableRowActions
                  positionActionsColumn="first"
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  renderRowActionMenuItems={({ row, closeMenu }) => [
                    <MenuItem
                      onClick={(event) => {
                        handleOpenInfoPromotor(row);
                        closeMenu();
                      }}
                    >
                      <ContactPage sx={{ mr: 1 }} /> <b>Ver Información</b>
                    </MenuItem>,
                    <MenuItem
                      onClick={(event) => {
                        handleOpenEditarPromotor(row);
                        closeMenu();
                      }}
                    >
                      <Edit sx={{ mr: 1 }} /> <b>Editar</b>
                    </MenuItem>,
                    <MenuItem
                      onClick={(event) => {
                        handleOpenModalEliminarPromotor(row);
                        closeMenu();
                      }}
                      sx={{ color: "firebrick" }}
                    >
                      <Delete sx={{ mr: 1 }} /> <b>Eliminar</b>
                    </MenuItem>,
                  ]}
                  muiTableHeadCellProps={{
                    align: "center",
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiTableBodyProps={{
                    sx: {
                      "& tr:nth-of-type(odd)": {
                        backgroundColor: theme.palette.background.alt,
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    align: "center",
                  }}
                  muiTablePaperProps={{
                    elevation: 0,
                  }}
                  initialState={{
                    pagination: {
                      pageSize: 10,
                      pageIndex: 0,
                    },
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [10, 20, 30, 50, 100],
                    showFirstButton: false,
                    showLastButton: false,
                    SelectProps: {
                      native: true,
                    },
                    labelRowsPerPage: "Número de filas visibles",
                  }}
                />
              </Box>
            </Box>
          </Box>
          {/*//////////////////////////////////  MODAL NUEVO PROMOTOR  /////////////////////////////////////*/}
          <Modal open={modalPromotor} onClose={handleCloseModalPromotor}>
            <Box sx={modalStyle}>
              <Typography
                className={isSmallScreen ? "text-center" : ""}
                variant="h4"
                component="h2"
                hidden={isSmallScreen}
              >
                <b>
                  <PersonAdd sx={{ fontSize: 32, mb: 1, mr: 1 }} /> Nuevo
                  Promotor Comunitario
                </b>
              </Typography>
              <Grid container hidden={!isSmallScreen}>
                <Grid item xs={1}>
                  <PersonAdd sx={{ fontSize: 29, mb: 1 }} />
                </Grid>
                <Grid item xs={10}>
                  <Typography
                    className="text-center"
                    variant="h5"
                    mt={1}
                    ml={1}
                  >
                    <b>Nuevo Promotor Comunitario</b>
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ mt: 2, mb: 5 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Nombres"
                    variant="outlined"
                    fullWidth
                    value={nombrePromotor}
                    onChange={handleNombrePromotor}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Apellidos"
                    variant="outlined"
                    fullWidth
                    value={apellidoPromotor}
                    onChange={handleApellidoPromotor}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Cédula"
                    variant="outlined"
                    type="number"
                    fullWidth
                    value={cedulaPromotor}
                    onChange={handleCedulaPromotor}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="telefono" variant="outlined">
                      Teléfono
                    </InputLabel>
                    <OutlinedInput
                      value={telefonoPromotor.textmask}
                      onChange={handleTelefonoPromotor}
                      name="textmask"
                      id="telefono"
                      inputComponent={TextMaskCustom}
                      label="Teléfono"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="estado"> Estado </InputLabel>
                    <Select
                      label="Estado"
                      name="estadoPromotor"
                      value={estadoPromotor}
                      onChange={handleEstadoPromotor}
                    >
                      <MenuItem value={""}>
                        <em> Seleccione un Estado... </em>
                      </MenuItem>
                      {estados.map((dat, index) => (
                        <MenuItem value={dat.idestado}>{dat.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="municipioPromotor"> Municipio </InputLabel>
                    <Select
                      label="Municipio"
                      name="municipioPromotor"
                      value={municipioPromotor}
                      onChange={handleMunicipioPromotor}
                      disabled={estadoPromotor === ""}
                    >
                      <MenuItem value={""}>
                        <em> Seleccione un Municipio... </em>
                      </MenuItem>
                      {municipios.map((dat, index) => (
                        <MenuItem value={dat.idmunicipios}>
                          {dat.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="parroquiaPromotor"> Parroquia </InputLabel>
                    <Select
                      label="Parroquia"
                      name="parroquiaPromotor"
                      value={parroquiaPromotor}
                      onChange={handleParroquiaPromotor}
                      disabled={municipioPromotor === ""}
                    >
                      <MenuItem value={""}>
                        <em> Seleccione una Parroquia... </em>
                      </MenuItem>
                      {parroquias.map((dat, index) => (
                        <MenuItem value={dat.idparroquias}>
                          {dat.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Comunidad"
                    variant="outlined"
                    fullWidth
                    value={comunidadPromotor}
                    onChange={handleComunidadPromotor}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Censo"
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={censoPromotor}
                    onChange={handleCensoPromotor}
                  />
                </Grid>
              </Grid>
              <Divider sx={{ mt: 5, mb: 3 }} />
              <Grid
                container
                sx={{ mt: 2 }}
                spacing={1}
                justifyContent={isSmallScreen ? "center" : "flex-end"}
              >
                <Grid item xs={isSmallScreen ? 5 : 0}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseModalPromotor}
                    fullWidth={isSmallScreen}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={isSmallScreen ? 5 : 0}>
                  <Button
                    variant="contained"
                    sx={{ bgcolor: "teal", color: "white" }}
                    fullWidth={isSmallScreen}
                    onClick={(event) => {
                      handleSubmitPromotor();
                      handleCloseModalPromotor(false);
                    }}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
          {/*//////////////////////////////////  MODAL EDITAR PROMOTOR  ////////////////////////////////////*/}
          <Modal open={modalEditarPromotor} onClose={handleCloseEditarPromotor}>
            <Box sx={modalStyle}>
              <Typography
                className={isSmallScreen ? "text-center" : ""}
                variant="h4"
                component="h2"
                hidden={isSmallScreen}
              >
                <b>
                  <Edit sx={{ fontSize: 32, mb: 1, mr: 1 }} /> Editar Promotor
                  Comunitario
                </b>
              </Typography>
              <Grid container hidden={!isSmallScreen}>
                <Grid item xs={1}>
                  <Edit sx={{ fontSize: 29, mb: 1 }} />
                </Grid>
                <Grid item xs={10}>
                  <Typography
                    className="text-center"
                    variant="h5"
                    mt={1}
                    ml={1}
                  >
                    <b>Editar Promotor Comunitario</b>
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ mt: 2, mb: 5 }} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Nombres"
                    variant="outlined"
                    fullWidth
                    value={nombrePromotorEditar}
                    onChange={handleNombrePromotorEditar}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Apellidos"
                    variant="outlined"
                    fullWidth
                    value={apellidoPromotorEditar}
                    onChange={handleApellidoPromotorEditar}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Cédula"
                    variant="outlined"
                    type="number"
                    fullWidth
                    value={cedulaPromotorEditar}
                    onChange={handleCedulaPromotorEditar}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="telefonoEditar" variant="outlined">
                      Teléfono
                    </InputLabel>
                    <OutlinedInput
                      value={telefonoPromotorEditar.textmask}
                      onChange={handleTelefonoPromotorEditar}
                      name="textmask"
                      id="telefonoEditar"
                      inputComponent={TextMaskCustom}
                      label="Teléfono"
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="estadoEditar"> Estado </InputLabel>
                    <Select
                      label="Estado"
                      name="estadoPromotorEditar"
                      value={estadoPromotorEditar}
                      onChange={handleEstadoPromotorEditar}
                    >
                      <MenuItem value={""}>
                        <em> Seleccione un Estado... </em>
                      </MenuItem>
                      {estados.map((dat, index) => (
                        <MenuItem value={dat.idestado}>{dat.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="municipioPromotorEditar">
                      {" "}
                      Municipio{" "}
                    </InputLabel>
                    <Select
                      label="Municipio"
                      name="municipioPromotorEditar"
                      value={municipioPromotorEditar}
                      onChange={handleMunicipioPromotorEditar}
                      disabled={estadoPromotorEditar === ""}
                    >
                      <MenuItem value={""}>
                        <em> Seleccione un Municipio... </em>
                      </MenuItem>
                      {municipios.map((dat, index) => (
                        <MenuItem value={dat.idmunicipios}>
                          {dat.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <InputLabel id="parroquiaPromotorEditar">
                      {" "}
                      Parroquia{" "}
                    </InputLabel>
                    <Select
                      label="Parroquia"
                      name="parroquiaPromotorEditar"
                      value={parroquiaPromotorEditar}
                      onChange={handleParroquiaPromotorEditar}
                      disabled={municipioPromotorEditar === ""}
                    >
                      <MenuItem value={""}>
                        <em> Seleccione una Parroquia... </em>
                      </MenuItem>
                      {parroquias.map((dat, index) => (
                        <MenuItem value={dat.idparroquias}>
                          {dat.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Comunidad"
                    variant="outlined"
                    fullWidth
                    value={comunidadPromotorEditar}
                    onChange={handleComunidadPromotorEditar}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="outlined-basic"
                    label="Censo"
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={censoPromotorEditar}
                    onChange={handleCensoPromotorEditar}
                  />
                </Grid>
              </Grid>
              <Divider sx={{ mt: 5, mb: 3 }} />
              <Grid
                container
                sx={{ mt: 2 }}
                spacing={1}
                justifyContent={isSmallScreen ? "center" : "flex-end"}
              >
                <Grid item xs={isSmallScreen ? 5 : 0}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseEditarPromotor}
                    fullWidth={isSmallScreen}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={isSmallScreen ? 5 : 0}>
                  <Button
                    variant="contained"
                    sx={{ bgcolor: "teal", color: "white" }}
                    fullWidth={isSmallScreen}
                    onClick={(event) => {
                      handleEditarPromotor();
                      handleCloseEditarPromotor(false);
                    }}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
          {/*//////////////////////////////////  MODAL ELIMINAR PROMOTOR  //////////////////////////////////*/}
          <Modal
            open={modalEliminarPromotor}
            onClose={handleCloseEliminarPromotor}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            slotProps={{ backdrop: { style: { opacity: 0.2 } } }}
          >
            <Box sx={modalEliminarStyle}>
              <Typography variant="h4" className="text-center" sx={{ mt: 2 }}>
                {" "}
                ¿Está seguro de eliminar este registro?{" "}
              </Typography>
              <Divider sx={{ mt: 5, mb: 3 }} />
              <Grid
                container
                sx={{ mt: 1 }}
                spacing={1}
                justifyContent="center"
              >
                <Grid item xs={5} sm={3}>
                  <Button
                    variant="contained"
                    color="error"
                    size="large"
                    onClick={handleCloseEliminarPromotor}
                    fullWidth
                  >
                    {" "}
                    No{" "}
                  </Button>
                </Grid>
                <Grid item xs={5} sm={3}>
                  <Button
                    variant="contained"
                    size="large"
                    sx={{ bgcolor: "teal", color: "white" }}
                    fullWidth
                    onClick={(event) => {
                        handleEliminar();
                        handleCloseEliminarPromotor(false);
                      }}
                  >
                    {" "}
                    Si{" "}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
          {/*//////////////////////////////////  MODAL VER INFORMACION  ///////////////////////////////////*/}
          <Modal open={modalInfoPromotor} onClose={handleCloseInfoPromotor}>
            <Box sx={modalInfoStyle}>
              <Typography
                className="text-center"
                variant={isSmallScreen ? "h4" : "h2"}
              >
                <b>
                  {datosInfoPromotor.nombres} {datosInfoPromotor.apellidos}
                </b>
              </Typography>
              <Divider sx={{ mt: 3, mb: 3 }} />
              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} sm={5}>
                  <Typography variant={isSmallScreen ? "h6" : "h5"}>
                    <b>Cédula: </b>
                    {datosInfoPromotor.cedula}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography variant={isSmallScreen ? "h6" : "h5"}>
                    <b>Teléfono: </b>
                    {datosInfoPromotor.telefono}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography variant={isSmallScreen ? "h6" : "h5"}>
                    <b>Estado: </b>
                    {datosInfoPromotor.nombreEstado}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography variant={isSmallScreen ? "h6" : "h5"}>
                    <b>Municipio: </b>
                    {datosInfoPromotor.nombreMunicipio}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography variant={isSmallScreen ? "h6" : "h5"}>
                    <b>Parroquia: </b>
                    {datosInfoPromotor.nombreParroquia}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <Typography variant={isSmallScreen ? "h6" : "h5"}>
                    <b>Comunidad: </b>
                    {datosInfoPromotor.comunidad}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <Typography variant={isSmallScreen ? "h6" : "h5"}>
                    <b>Censo: </b>
                    {datosInfoPromotor.censo}
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ mt: 3, mb: 2 }} />
              <Grid
                container
                sx={{ mt: 2 }}
                spacing={1}
                justifyContent={isSmallScreen ? "center" : "flex-end"}
              >
                <Grid item xs={isSmallScreen ? 5 : 0}>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCloseInfoPromotor}
                    fullWidth={isSmallScreen}
                    size={isSmallScreen ? "large" : "medium"}
                  >
                    Cerrar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Modal>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

const data = [
  {
    name: {
      firstName: "John",
      lastName: "Doe",
    },
    address: "261 Erdman Ford",
    city: "East Daphne",
    state: "Kentucky",
  },
  {
    name: {
      firstName: "Jane",
      lastName: "Doe",
    },
    address: "769 Dominic Grove",
    city: "Columbus",
    state: "Ohio",
  },
  {
    name: {
      firstName: "Joe",
      lastName: "Doe",
    },
    address: "566 Brakus Inlet",
    city: "South Linda",
    state: "West Virginia",
  },
  {
    name: {
      firstName: "Kevin",
      lastName: "Vandy",
    },
    address: "722 Emie Stream",
    city: "Lincoln",
    state: "Nebraska",
  },
  {
    name: {
      firstName: "Joshua",
      lastName: "Rolluffs",
    },
    address: "32188 Larkin Turnpike",
    city: "Charleston",
    state: "South Carolina",
  },
];

export default Promotores;
